import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import UserDetails from './submodules/userDetails';
import ListUserSegments from './submodules/listUserSegments';

const updateUserSegmentToVipDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserSegmentToVip]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/updateUserSegmentToVip`}
				component={UserDetails}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/updateUserSegmentToVip/listUserSegments`}
				component={ListUserSegments}
				exact
			/>
			<Redirect to={`${path}/updateUserSegmentToVip`} />
		</Switch>
	);
};

export default updateUserSegmentToVipDashboard;
